import React from "react";
import Skeleton, { SkeletonBlock } from "../ui/Skeleton";

/** Readable-register loading placeholder for create/edit event. */
export default function CreateEventLoadingSkeleton({ label = "Loading event…" }) {
  return (
    <div
      className="min-h-screen bg-canvas max-w-page mx-auto px-4 pt-6 pb-8"
      aria-busy="true"
      aria-label={label}
      data-testid="create-event-loading"
    >
      <Skeleton label={label} className="space-y-6">
        <SkeletonBlock className="h-11 w-28" />
        <div className="space-y-2">
          <SkeletonBlock className="h-8 w-44 rounded" />
          <SkeletonBlock className="h-5 w-full max-w-sm rounded" />
        </div>
        <div className="space-y-4 pt-2">
          {[1, 2, 3, 4].map((i) => (
            <SkeletonBlock key={i} className="h-36 rounded-card" />
          ))}
        </div>
      </Skeleton>
    </div>
  );
}
